import { DocumentCreate, Document } from '@quromedical/models';
import { trpc } from 'trpc';

export class DocumentApi {
  createDocument = async (document: DocumentCreate): Promise<Document> => {
    return trpc.client.document.create.mutate(document);
  };

  getDownloadURL = async (id: string): Promise<string> => {
    return trpc.client.document.getDownloadURL.query({ id });
  };
}
